import TimeInterval from './time-interval.vue'

let Plugin = {},
    vueInstance;

Plugin.install = function (Vue, opt) {
    opt.root.timeInterval = function () {
        // if (!vueInstance) {
        let el = document.createElement('div')
        document.querySelector('body').appendChild(el)

        let vueClass = Vue.extend(TimeInterval);

        vueInstance = new vueClass({
            el: el,
            router: opt.router
        })
        // }

        vueInstance.wrapshow = true
        return vueInstance.showPicker(...arguments)
    }
}


export default Plugin;
